import React from 'react';
import { Banner } from 'components/atoms/banner';
import { useViewport } from 'components/templates/viewportProvider';
import { EventVenueCard } from 'components/molecules/eventVenueCard';
import { BannerVideoButton } from 'components/atoms/bannerVideoButton';
import { DateUtil } from 'utils/DateUtil';
import locationMarker from 'assets/images/marker.png';
import { CURRENT_COUNTRY_CODE } from 'config/env';
import useEventUpdater from 'hooks/useEventUpdater';
//eslint-disable-next-line
import styles from "./styles.scss";

const MAX_VENUES = 3;

const EventDetailsBanner = props => {
  const { height, isMobile } = useViewport();
  const {
    title,
    genres,
    event_poster,
    poster_mobile,
    venues,
    thumbnail,
    videoUrl,
    onBookNow,
    standing_ticket_price,
    seating_ticket_price,
  } = props.data;

  const minSeatingPrice =
    Array.isArray(seating_ticket_price) && seating_ticket_price.length > 0
      ? seating_ticket_price.reduce((min, curr) => Math.min(min, curr.price), Infinity)
      : 0;
  const hasTicketsAvailable = standing_ticket_price > 0 || minSeatingPrice > 0;

  
  const eventVenues = venues.length > 0 && venues.slice(0, MAX_VENUES);
  const className = 'event-details-banner';
  const dates = venues && venues[0].eventDates;
  const countryCode = CURRENT_COUNTRY_CODE === '+1' ? 'USA' : 'INDIA';
  const validEventDates = useEventUpdater(dates, countryCode, true);
  let sortedDates = DateUtil.getSortedDates(validEventDates);
  const updated_dates = DateUtil.getFilteredDates(sortedDates).reverse();

  const extractDates = updated_dates?.map(date => {
    let value = DateUtil.getEventDetailBannerDate(
      date.concert_date,
      date.start_time
    );
    return {
      value: date.id,
      label: value,
      id: date.id,
      concert_date: date.concert_date,
      end_time: date.end_time,
      music_event_venue_id: date.music_event_venue_id,
      start_time: date.start_time,
    };
  });


  let imageUrl = event_poster;
  if (isMobile) {
    imageUrl = poster_mobile;
  }

  const renderTitle = () => {
    return (
      <div className={'event-detail-title'}>
        <h1>{title}</h1>
        <span>{genres.join(', ')}</span>
      </div>
    );
  };

  const MOBILE_DATES_LIMIT = 3;
  const visibleDates = extractDates.slice(0, MOBILE_DATES_LIMIT);
  const extraCount = extractDates.length - MOBILE_DATES_LIMIT;

  const renderVenueCardMobile = () => {
    return (
      <div className={'mobile-venue-card'}>
        <div className={'inner-container'}>
          <div className={'venue-location-container'}>
            <div className={'location-name'}>
              <img src={locationMarker} alt={'marker'} />
              <div>
                {venues && venues[0].name && <h3>{venues[0].name}</h3>}
                <h3>{venues && venues[0].location}</h3>
              </div>
            </div>
            <div className={'date-list'}>
              {extractDates.length > 0 ? (
                <>
                  {visibleDates.map(date => (
                    <h4 key={date.id} className={'date-item'}>{date.label}</h4>
                  ))}
                  {extraCount > 0 && (
                    <h4 className={'more-dates'}>...{extraCount} more</h4>
                  )}
                </>
              ) : (
                <h3>Event Bookings Closed</h3>
              )}
            </div>
            {extractDates && extractDates.length > 0 && hasTicketsAvailable && (
              <button className={'book-now-button-mobile'} onClick={onBookNow}>
                Book Now
              </button>
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className={className} style={{ height }} id={'banner'}>
      <Banner
        containerClassName={'event-detail'}
        title={renderTitle()}
        imageUrl={imageUrl}
        thumbNailUrl={thumbnail}
        variableWidth={true}
      />
      {videoUrl && <BannerVideoButton videoUrl={videoUrl} />}
      {isMobile ? (
        renderVenueCardMobile()
      ) : (
        <div className={'banner-venue-container'}>
          {eventVenues &&
            eventVenues.map(event => {
              return (
                <div className={'venue-card-container'}>
                  <EventVenueCard
                    className={
                      dates.length > 3
                        ? 'event-detail-card add-width'
                        : 'event-detail-card'
                    }
                    venue={event}
                    type={'banner'}
                    filteredDates={updated_dates}
                  />
                  {updated_dates && updated_dates.length > 0 && hasTicketsAvailable && (
                    <div className={'book-now-container'}>
                      <button
                        className={'book-now-button'}
                        onClick={onBookNow}
                      >
                        BOOK NOW
                      </button>
                    </div>
                  )}
                </div>
              );
            })}
          {venues.length > MAX_VENUES && (
            <h4 className={'additional-venues'}>
              and {venues.length - MAX_VENUES} more venues of the event
            </h4>
          )}
        </div>
      )}
    </div>
  );
};

export default EventDetailsBanner;
